export class ProfileInfo {
  constructor(
    public ribbonEnv: string,
    public inProduction: boolean,
    public openAPIEnabled: boolean,
    public enableDevis: boolean,
    public enableDemandesRecues: boolean,
    public activeProfiles: string[],
    public displayRibbonOnProfiles: string[],
    public git: any,
    public currentTime: any
  ) {}

  public static hydrate(obj: any): ProfileInfo {
    const ribbonOnProfiles =
      obj.displayRibbonOnProfiles ?? (obj['display-ribbon-on-profiles'] ? obj['display-ribbon-on-profiles'].split(',') : []);
    const ribbonEnv = ribbonOnProfiles.find((profile: any) => obj.activeProfiles.includes(profile)) ?? '';
    return new ProfileInfo(
      ribbonEnv,
      obj.inProduction ?? obj.activeProfiles?.includes('prod') ?? false,
      obj.openAPIEnabled ?? obj.activeProfiles?.includes('api-docs') ?? false,
      obj.enableDevis ?? obj.activeProfiles?.includes('feature-devis') ?? false,
      obj.enableDemandesRecues ?? obj.activeProfiles?.includes('feature-tls') ?? false,
      obj.activeProfiles,
      ribbonOnProfiles,
      obj.git,
      obj['CurrentTime']
    );
  }
}
